module.exports = __webpack_public_path__ + "static/transportation-for-seniors-1-ad2f7dd7bf812dd81e52ebcc450e31a5.jpg";